import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { SelectedSubstationForSchematic } from '../../nec-modals/nec-add-new-instance-equipment/nec-add-new-instance-equipment.component';
import { ConnectorSwitchService } from '../../../../services/connector-switch.service';
import { ToastrService } from 'ngx-toastr';
import { ConnectorSwitchViewModel, EditConnectorSwitchDto, ConnectorSwitchFilter, ConnectorSwitchSearchType } from '../../../../models/connector-switch.model';
import { GeographicalRegion } from '../../../../models/geographical-region.model';
import { SubGeographicalRegion } from '../../../../models/sub-geographical-regions.model';
import { GeographicalRegionService } from '../../../../services/geographical-region.service';
import { SubGeographicalRegionService } from '../../../../services/sub-geographical-region.service';
import { BaseVoltageService } from '../../../../services/base-voltage.service';
import { SubstationTemplateService } from '../../../../services/substation-template.service';
import { SubstationTemplateForSelectDataOut } from '../../../../models/substation-template.model';
import { SelectSubstationDto } from '../../../../models/substation-template-instance.model';
import { ObjectDropdownComponent } from '../../../common/object-dropdown/object-dropdown.component';
import { UtilitySharedService } from '../../../../services/shared//utility-shared.service';
import { PermissionsService } from '../../../../services/permissions.service';

@Component({
  selector: 'lib-nec-connector-switch',
  templateUrl: './nec-connector-switch.component.html',
  styleUrls: ['./nec-connector-switch.component.scss', '../../network-entity-classes.component.scss'],
  standalone: false
})
export class NecConnectorSwitchComponent implements OnInit {
  @Input() tabsTypes!: {value: string, text: string}[];
  @Input() allTypes!: {value: string, text: string}[];
  @Input() activeItemId!: number;

  modalOpened: boolean = false;
  isAddNewInstanceEquipmentOpen: boolean = false;
  @Output() openSubstationSchematic = new EventEmitter<SelectedSubstationForSchematic>();
  ConnectorSwitchSearchType = ConnectorSwitchSearchType;
  filter = new ConnectorSwitchFilter();

  @ViewChild('closeEditModal') closeEditModal!: ElementRef;
  @ViewChild('substationTemplateDropdown') substationTemplateDropdown!: ObjectDropdownComponent;
  @ViewChild('substationTemplateInstanceDropdown') substationTemplateInstanceDropdown!: ObjectDropdownComponent;
  @ViewChild('dropdownVoltage') dropdownVoltage!: ObjectDropdownComponent;
  @ViewChild('destinationEquipmentDropdown') destinationEquipmentDropdown!: ObjectDropdownComponent;
  @ViewChild('sourceEquipmentDropdown') sourceEquipmentDropdown!: ObjectDropdownComponent;
  
  entities: ConnectorSwitchViewModel [] = [];

  currentPage: number = 1;
  pageSize: number = 10;
  pageSizes = [10, 20];
  count: number = 1;

  filterOpened: boolean = false;
  searchDropdownOpened: boolean = false;

  isEdit: boolean = false;
  actionMenuOpenForId: number | null = null;

  tabs: { value: string, text: string, count: number }[] = [];
  selectedTab!: { value: string, text: string, count: number, active?: boolean };
  selectedEntity: EditConnectorSwitchDto = new EditConnectorSwitchDto();
  currentConnectorType!: {value: string, text: string};

  baseVoltages: any[] = [];
  substationTemplateOptions: SubstationTemplateForSelectDataOut[] = [];
  substationEquipmentOptions: {id: number, name:string}[] = [];
  selectedEquipmentType!: {value: string, name: string};

  baseVoltageValue: any | null = null;

  substationOptions: SelectSubstationDto[] = [];
  utilityId: number | null = 0;

  selectedEquipmentId: { value: number | null } | null = null;

  geoRegions: GeographicalRegion[] = [];
  allSubGeoRegions: SubGeographicalRegion[] = [];
  baseVoltageOptions: any[] = [];

  constructor(
      private connectorSwitchService: ConnectorSwitchService,
      private utilitySharedService: UtilitySharedService,
      private toastr: ToastrService,
      private geographicalRegionService: GeographicalRegionService,
      private subGeographicalRegionService: SubGeographicalRegionService,
      private substationTemplateService: SubstationTemplateService,
      private baseVoltageService: BaseVoltageService,
      public permissionsService: PermissionsService
  ) {
        this.utilityId = utilitySharedService.getUtilityId();
      }

  ngOnInit(): void {
    this.filter.searchType = ConnectorSwitchSearchType.Name;
    this.initializeTabs();
    this.selectedTab = this.tabs[0];
    this.selectedEquipmentType = {value: this.selectedTab.value, name: this.selectedTab.text};
    this.currentConnectorType = this.allTypes.find(x => x.value === this.selectedTab.value)!;
    this.getAll();
    this.getEquipmentStats();
    this.loadGeographicalRegions();
    this.loadAllSubGeographicalRegions();
    this.loadSubstationTemplates();
    this.loadBaseVoltages();
  }

  initializeTabs() {
    this.tabs = this.tabsTypes.map(t => ({
      ...t,
      count: 0
    }));
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.getAll();
  }

  onPageSizeChange(size: number) {
    this.pageSize = size;
    this.currentPage = 1;
    this.getAll();
  }

  getEquipmentStats(){
      this.tabs.forEach(tab => {
        this.loadEquipmentStatForType(tab.value);
      });
  }

  loadEquipmentStatForType(type: string) {
    this.connectorSwitchService.getEquipmentStats({ equipmentType: type }).subscribe({
      next: (response: any) => {
        const data = response.body.data;
        const tab = this.tabs.find(t => t.value === type);
        if (tab) {
          tab.count = data.count;
        }
      }
    });
  }

  openAddModal() {
    this.isAddNewInstanceEquipmentOpen = true;
  }

  onAddNewInstanceEquipmentClosed() {
    this.isAddNewInstanceEquipmentOpen = false;
  }

  onAddNewInstanceEquipmentProceed(selected: SelectedSubstationForSchematic) {
    this.isAddNewInstanceEquipmentOpen = false;
    this.openSubstationSchematic.emit(selected);
  }

  switchTab(tab: any) {
    if(tab){
      this.selectedTab = tab;
      this.selectedEquipmentType = {value: this.selectedTab.value, name: this.selectedTab.text};
      this.currentPage = 1;
      this.currentConnectorType = this.allTypes.find(x => x.value === this.selectedTab.value)!;
      this.getAll();
    }
  }

  toggleActionMenu(entity: any, event: MouseEvent) {
    event.stopPropagation();
    this.actionMenuOpenForId =
      this.actionMenuOpenForId === entity.id ? null : entity.id;
  }

  selectEntity(id: number) {
    this.isEdit = true;
    this.modalOpened = true;
    this.selectedEntity = new EditConnectorSwitchDto();
    this.selectedEquipmentId = { value: id };
  }

  selectSearchType(searchType: ConnectorSwitchSearchType){
    this.filter.searchType = searchType;
    this.searchDropdownOpened = false;
  }

  onFilterApplied() {
    this.currentPage = 1;
    this.getAll();
    this.filterOpened = false;
  }

  getSearchTypeLabel(): string {
    switch(this.filter.searchType) {
      case ConnectorSwitchSearchType.Name:
        return 'Asset Name';
      case ConnectorSwitchSearchType.SubstationName:
        return 'Substation Name';
      default:
        return 'Asset Name';
    }
  }

  getAll() {
    let dataIn = {
      pageInfo: {
        page: this.currentPage,
        pageSize: this.pageSize,
      },
      filterParams: this.filter,
      equipmentType: this.selectedTab.value,
    };
    this.connectorSwitchService.getAll(dataIn).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.entities = responseData.data.data;
          this.count = responseData.data.count;
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  reloadTable(){
    this.getAll();
    this.getEquipmentStats();
  }

  loadGeographicalRegions() {
    this.geographicalRegionService.getAllForSelect().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData && responseData.status === 'OK') {
          this.geoRegions = responseData.data.map((geoRegion: GeographicalRegion) => ({
            ...geoRegion,
            name: geoRegion.name.toUpperCase()
          }));
        } else {
          this.toastr.error(responseData?.message || 'Failed to fetch geographical regions');
        }
      },
      error: (_) => {
        this.toastr.error('Failed to fetch geographical regions');
      },
    });
  }

  loadAllSubGeographicalRegions() {
    this.subGeographicalRegionService.getAllForMappings().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData && responseData.status === 'OK') {
          this.allSubGeoRegions = responseData.data.map((subGeoRegion: SubGeographicalRegion) => ({
            ...subGeoRegion,
            name: subGeoRegion.name.toUpperCase()
          }));
        } else {
          this.toastr.error(responseData?.message || 'Failed to fetch sub-geographical regions');
        }
      },
      error: (_) => {
        this.toastr.error('Failed to fetch sub-geographical regions');
      },
    });
  }

  loadSubstationTemplates() {
    this.substationTemplateService.getAllForSelect().subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData && responseData.status === 'OK') {
          this.substationTemplateOptions = responseData.data;
        } else {
          this.substationTemplateOptions = [];
        }
      },
      error: (_) => {
        this.toastr.error('Failed to fetch substation templates');
      },
    });
  }

  loadBaseVoltages() {
    this.baseVoltageService.getAllForMappings(this.utilityId!).subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData && responseData.status === 'OK') {
          this.baseVoltageOptions = responseData.data;
        } else {
          this.baseVoltageOptions = [];
        }
      },
      error: (_) => {
        this.toastr.error('Failed to fetch base voltages');
      },
    });
  }

  @HostListener('document:click')
  closeMenu() {
    if (this.actionMenuOpenForId !== null) {
      this.actionMenuOpenForId = null;
    }
  }
}